import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Theme } from '../../styles';
import { AppIcon } from '../icons';
import { Row } from '../layout';
import { AppText } from '../typography';
export const CallLogWarningMessage = ({ message }) => {
    return (_jsxs(Row, { mr: 5, backgroundColor: Theme.colors.errorPink, borderRadius: "10px", padding: "10px 15px", justifyContent: "center", alignItems: "center", children: [_jsx(Row, { flexShrink: 0, mr: 4, children: _jsx(AppIcon, { name: 'AlertIcon', color: Theme.colors.red60, size: "medium" }) }), _jsx(AppText, { color: "red60", style: {
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                }, children: message })] }));
};
//# sourceMappingURL=call_log_warning_message.js.map